import { Trans } from "@lingui/macro";
import { UiBox, UiTypography } from "@smp/ui";
import { IconArrowUpRight } from "@tabler/icons-react";
import { forwardRef } from "react";

import { useContextPolotnoTemplates } from "@/components/features/polotno_templates/context";

import { useStyles } from "./create_button.css";

export const CreateButton = forwardRef<HTMLDivElement>((_props, ref) => {
  const classes = useStyles();
  const {
    actions: { onCreateNew },
  } = useContextPolotnoTemplates();

  return (
    <UiBox className={classes.button} onClick={onCreateNew} ref={ref}>
      <UiBox className={classes.button__inner_hover}>
        <UiTypography className={classes.text}>
          <Trans>Let’s go</Trans>
        </UiTypography>
        <IconArrowUpRight className={classes.icon} />
      </UiBox>

      <UiBox className={classes.button__inner_default}>
        <UiTypography className={classes.text}>
          <Trans>Make your own template</Trans>
        </UiTypography>
      </UiBox>
    </UiBox>
  );
});
